import { render, staticRenderFns } from "./KanbanBoard.vue?vue&type=template&id=bb3b0158&scoped=true"
import script from "./KanbanBoard.vue?vue&type=script&lang=js"
export * from "./KanbanBoard.vue?vue&type=script&lang=js"
import style0 from "./KanbanBoard.vue?vue&type=style&index=0&id=bb3b0158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3b0158",
  null
  
)

export default component.exports